import { render, staticRenderFns } from "./DetailsHeader.vue?vue&type=template&id=0ab7794a&scoped=true&"
import script from "./DetailsHeader.vue?vue&type=script&lang=js&"
export * from "./DetailsHeader.vue?vue&type=script&lang=js&"
import style0 from "./DetailsHeader.vue?vue&type=style&index=0&id=0ab7794a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab7794a",
  null
  
)

export default component.exports